import { useState, useRef, useEffect } from "react";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface variableKeys {
  type?: string;
  value?: string;
  name?: string;
}

const keyIcon = (type: string | undefined) => {
  if (type === "text") return ["text", "str"];
  if (type === "array") return ["list", "array"];
  if (type === "date") return ["calendar", "date"];
  if (type === "boolean") return ["toggle-large-on", "bool"];
  if (type === "number") return ["hashtag", "num"];
  if (type === "file") return ["file", "file"];
  if (type === "float") return ["hashtag", "num"];
  if (type === "integer") return ["hashtag", "num"];
  if (type === "timestamp") return ["calendar", "date"];
  return ["text", "str"];
};

export const VariableKeyBox = ({
  type = "text",
  value = "This is the value of the variable written in plain english",
  name = "variable-key",
}: variableKeys) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string | undefined>("auto");

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isOpen]);

  return (
    <div className="rounded-lg border border-neutral-silent transition-all duration-300">
      <div className="py-0 px-3 bg-neutral-object-accent-silent flex items-center space-x-2">
        <Icon name={keyIcon(type)[0]} type="far" className="text-body" />
        <span className="text-body-loud">{name}</span>
        <span className="text-body-quiet">{keyIcon(type)[1]}</span>
        <Button
          aria-label="Toggle"
          size="icon"
          variant="ghost"
          onClick={() => setIsOpen((prev) => !prev)}
          className="ml-auto transition-transform"
        >
          <Icon
            name="angle-up"
            type="far"
            className={`text-body-quiet transition-transform duration-300 ${
              isOpen ? "rotate-0" : "rotate-180"
            }`}
          />
        </Button>
      </div>
      <div
        ref={contentRef}
        style={{ maxHeight: height }}
        className="transition-all duration-300 overflow-hidden"
      >
        <div className="rounded-b-lg bg-neutral-object-accent py-2 px-3 text-body-loud">
          {value}
        </div>
      </div>
    </div>
  );
};
